import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getList } from "./AlarmAPI";

const initialState = {
//    prjId:'',
//    prjName: '',
    alarmsData: {},
    apiStatus: 'idle'
}

export const getAlarmsDataAsync = createAsyncThunk(
    'alarm/getAlarmsDataAsync',
    async (input, thunkAPI) => {
        let res;
        try {
            res = getList(input);
        } catch (e) {
            thunkAPI.rejectWithValue({ errorMessage: 'Fetch error' });
            return;
        }

        return res;
    }
);

const alarmListSlice = createSlice({
    name: "alarm",
    initialState,
    reducers: {
    },

    extraReducers: (builder) => {
        builder
            .addCase(getAlarmsDataAsync.pending, (state) => {
                state.apiStatus = 'loading';
            })
            .addCase(getAlarmsDataAsync.fulfilled, (state, action) => {
                state.apiStatus = 'idle';
                //if (Boolean(action.payload.success)) {
                state.alarmsData = action.payload;
                //}
            })
            .addCase(getAlarmsDataAsync.rejected, (state, action) => {
                state.apiStatus = 'idle';
                state.alarmsData = {};
            });
    },
});

export const selectAlarmsData = (state) => state.alarm.alarmsData;

export default alarmListSlice;
